import React, { Component } from 'react'

// ui
import { Tooltip, Comment, List, Form, Input, Button, Avatar } from 'antd'
import moment from 'moment';

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

// const 
const { TextArea } = Input;

const Editor = ({ onChange, onSubmit, submitting, value }) => (
    <div>
        <Form.Item style={{ width: '100%' }} wrapperCol={{ sm: { span: 24 }, md: { span: 24 } }}>
            <TextArea rows={4} onChange={onChange} value={value} />
        </Form.Item>
        <Form.Item>
            <Button loading={submitting} onClick={onSubmit} type="primary">
                Add Comment
        </Button>
        </Form.Item>
    </div>
);

class ListComments extends Component {

    state = {
        comments: [],
        submitting: false,
        value: '',
    };

    componentDidMount = () => {
        this.setState({value: ''})
    }

    componentWillReceiveProps = () => {
        this.setState({value: ''})
    }

    handleSubmit = () => {
        if (!this.state.value) {
            return;
        }

        this.setState({
            submitting: true,
        });

        setTimeout(() => {
            this.props.addComment({
                owner_id: this.props.userInfo.uid,
                avatar: this.props.userInfo.avatar,
                display_name: this.props.userInfo.display_name,
                report_id: this.props.report.report_id,
                content: this.state.value,
                created_time: moment() / 1000
            })
            this.setState({
                submitting: false,
                value: '',
            });
        }, 1000);
    };

    handleChange = e => {
        this.setState({
            value: e.target.value,
        });
    };

    render() {
        let data = this.props.comments
        const { submitting, value } = this.state;
        const { userInfo } = this.props

        return (
            <div style={{ width: '100%', paddingLeft: 30, paddingRight: 25 }}>
                {
                    data.length > 0 &&
                    <List
                        className="comment-list"
                        header={`${data.length} bình luận`}
                        itemLayout="horizontal"
                        dataSource={data}
                        renderItem={item => {
                            console.log("avatar : ", item.avatar)
                            let avatar = item.avatar 
                            if (avatar === '')
                                avatar = this.props.default_avatar
                            
                            return (
                                <li>
                                    <Comment
                                        //actions={item.actions}
                                        author={item.display_name}
                                        avatar={avatar}
                                        content={item.content}
                                        datetime={moment(item.created_time * 1000).fromNow()}
                                    />
                                </li>
                            )
                        }
                        }
                    />
                }
                <Comment
                    avatar={
                        <Avatar
                            src={userInfo.avatar}
                            alt={userInfo.display_name}
                        />
                    }
                    content={
                        <Editor
                            onChange={this.handleChange}
                            onSubmit={this.handleSubmit}
                            submitting={submitting}
                            value={value}
                        />
                    }
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        comments: state.qbreport.comments,
        userInfo: state.auth.userInfo,
        report: state.qbreport.current_report,
        default_avatar: state.user.default_avatar
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addComment: comment => {
            dispatch(ReportActions.action.addComment(comment))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListComments)